
    import HeadingSection from '../../components/MainComponent/HeadingSection.vue';
    import ProjectIntro from '../../components/Project/ProjectIntro.vue';
    import ProjectCarousel from '../../components/MainComponent/ProjectCarousel.vue';
    import ProjectsSection from '../../components/MainComponent/ProjectsSection.vue';

    export default {
        components: {
            HeadingSection,
            ProjectIntro,
            ProjectCarousel,
            ProjectsSection,
        },
        computed: {
            singleProjectPageData() {
                return this.$store.state.singleProjectPageData;
            },
        },
        async asyncData(context) {
            const path = context.route.params.slug;
            await context.app.$getDataFromCache(`/wp-json/wp/v2/projects?slug=${path}`)
                .then((response) => {
                    if (response.data.length) {
                        context.store.dispatch("setSingleProjectPageData", response.data[0]);
                    } else {
                        context.redirect('/');
                    }
                });
            await context.store.dispatch("setPageChangeAnimationValueFalse");
        },
    };
